import { useEffect } from "react";

// Generates a genuinely spinning favicon by rotating the shield crest on an
// offscreen canvas and periodically writing the frame back to the <link
// rel="icon"> tag. Rotation is intentionally slow (full turn ~24s).
const ROTATION_MS = 24000;
const STEPS = 160;
const FRAME_INTERVAL = ROTATION_MS / STEPS;

const DynamicFavicon = () => {
  useEffect(() => {
    const canvas = document.createElement("canvas");
    canvas.width = 64;
    canvas.height = 64;
    const ctx = canvas.getContext("2d");

    let link = document.querySelector("link[rel='icon'][sizes='32x32']") ||
      document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }

    const img = new Image();
    img.src = "/shield-square.png";

    let angle = 0;
    let intervalId;

    img.onload = () => {
      intervalId = setInterval(() => {
        angle = (angle + (Math.PI * 2) / STEPS) % (Math.PI * 2);
        ctx.clearRect(0, 0, 64, 64);
        ctx.save();
        ctx.translate(32, 32);
        ctx.rotate(angle);
        ctx.drawImage(img, -32, -32, 64, 64);
        ctx.restore();
        link.href = canvas.toDataURL("image/png");
      }, FRAME_INTERVAL);
    };

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, []);

  return null;
};

export default DynamicFavicon;
